import MomentUtils from "@date-io/moment";
import { DATE_PICKER_HEADER_FORMAT } from "config/constants";

export default class LocalizedUtils extends MomentUtils {
	getDatePickerHeaderText(date) {
		return this.format(date, DATE_PICKER_HEADER_FORMAT, {
			locale: this.locale
		});
	}
}
